// @module ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay
define("ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay.Details.View", [
  "ROOM4.CCAProductImageEventOverlay.CCAProductImageEventOverlay.View",
  "room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay.details.tpl",
], function (
  CCAProductImageEventOverlayView,
  room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay_details_tpl,
) {
  "use strict";

  function DetailsView(config) {
    CCAProductImageEventOverlayView.call(this, config);

    this.template =
      room4_ccaproductimageeventoverlay_ccaproductimageeventoverlay_details_tpl;
  }

  DetailsView.prototype = Object.create(
    CCAProductImageEventOverlayView.prototype,
  );
  DetailsView.prototype.constructor = DetailsView;

  return DetailsView;
});
